export const ErrorCode = {
  MISSING_INFORMATION_SALESFORCE_ID: 'MI_0001',
  MISSING_INFORMATION_ERROR_FETCH_SALESFORCE: 'MI_0002',
} as const

export type ErrorCode = (typeof ErrorCode)[keyof typeof ErrorCode]
